import { render } from "./RecoverSuccessPage.vue?vue&type=template&id=764c55ec"
import script from "./RecoverSuccessPage.vue?vue&type=script&lang=js"
export * from "./RecoverSuccessPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\CONSULT\\PROJECTS\\_HTML\\baden-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__